
import { createContext, useReducer } from "react";
import DeliveryReducer from "./DeliveryReducer";

const INITIAL_STATE = {
    deliveries: [],
    count: 1,
    isFetching: false,
    error: false,
    delivery: {},
    isFetchingAdd: false,
    errorAdd: false,
    isFetchingUpdate: false,
    errorUpdate: false,
    isFetchingActivate: false,
    errorActivate: false,
    transporteurs: [],
    livreurs: [],
};


export const DeliveryContext = createContext(INITIAL_STATE);

export const DeliveryContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(DeliveryReducer, INITIAL_STATE);
    
    return (
      <DeliveryContext.Provider
        value={{
          deliveries: state.deliveries,
          count: state.count,
          isFetching: state.isFetching,
          error: state.error,
          delivery: state.delivery,
          isFetchingAdd: state.isFetchingAdd,
          errorAdd: state.errorAdd,
          isFetchingUpdate: state.isFetchingUpdate,
          errorUpdate: state.errorUpdate,
          isFetchingActivate: state.isFetchingActivate,
          errorActivate: state.errorActivate,
          transporteurs: state.transporteurs,
          livreurs: state.livreurs,
          dispatch,
        }}
      >
        {children}
      </DeliveryContext.Provider>
    );
  };